export default "__VITE_ASSET__e133f81e__"